import type { IHypothesizedFunction } from '../../../../../../../../utils/types';
import type { HypoFunctionRowState } from '..//HypothesizedFunction';

export function isAtLeastOneChecked(currentRowValues: HypoFunctionRowState) {
  return (
    currentRowValues.is_attention ||
    currentRowValues.is_escape_or_avoidance ||
    currentRowValues.is_sensory ||
    currentRowValues.is_tangible
  );
}

export function areRowValuesSame(
  currentRowValues: HypoFunctionRowState,
  prevRowValues: IHypothesizedFunction,
) {
  return (
    currentRowValues.is_attention === prevRowValues.is_attention &&
    currentRowValues.is_escape_or_avoidance === prevRowValues.is_escape_or_avoidance &&
    currentRowValues.is_sensory === prevRowValues.is_sensory &&
    currentRowValues.is_tangible === prevRowValues.is_tangible
  );
}

export function isPostCallAllowed(
  currentRowValues: HypoFunctionRowState,
  prevRowValues: IHypothesizedFunction | null,
  isLastRow: boolean,
  date_selected: string | null,
) {
  let isAllowed =
    isLastRow && // post call only allowed for the last row.
    date_selected && // User should have selected a date
    // At least one checkbox should be checked
    isAtLeastOneChecked(currentRowValues);

  // If previous row data exists, compare current row values
  if (prevRowValues) {
    isAllowed = isAllowed && !areRowValuesSame(currentRowValues, prevRowValues);
  }

  return isAllowed;
}
